import { i18n } from 'i18n';

export const MONTHS = () => ({
	'1': i18n.t('Январь'),
	'2': i18n.t('Февраль'),
	'3': i18n.t('Март'),
	'4': i18n.t('Апрель'),
	'5': i18n.t('Май'),
	'6': i18n.t('Июнь'),
	'7': i18n.t('Июль'),
	'8': i18n.t('Август'),
	'9': i18n.t('Сентябрь'),
	'10': i18n.t('Октябрь'),
	'11': i18n.t('Ноябрь'),
	'12': i18n.t('Декабрь'),
});

export const MONTHS_OPTIONS = () =>
	Object.keys(MONTHS()).map((key) => ({
		label: MONTHS()[key as keyof ReturnType<typeof MONTHS>],
		value: key,
	}));
